import { render, staticRenderFns } from "./ModalRemove.vue?vue&type=template&id=fb9b3198&scoped=true&"
import script from "./ModalRemove.vue?vue&type=script&lang=js&"
export * from "./ModalRemove.vue?vue&type=script&lang=js&"
import style0 from "./ModalRemove.vue?vue&type=style&index=0&id=fb9b3198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9b3198",
  null
  
)

export default component.exports